import { BASE_URL_API } from 'constants/base-url-default'
import { EmployeesResponse } from 'types/employee'
import { getCookie } from 'utils/functions-cookie'
import { translateStatusFromBrToEn } from 'utils/translateStatusFromBrToEn'

type ParamsFetchEmployees = {
  link?: string
  subscriptionStatus?: string
  email?: string
  offset?: number
}

export const fetchEmployees = async ({
  link,
  subscriptionStatus,
  email,
  offset,
}: ParamsFetchEmployees = {}) => {
  const authToken = getCookie('auth_token')
  const baseUrl = `${BASE_URL_API}/employees/`
  const url = link ? `${baseUrl}${link}` : baseUrl

  const status = subscriptionStatus
    ? translateStatusFromBrToEn(subscriptionStatus)
    : ''

  const params = new URLSearchParams()

  if (status) {
    params.append('status', status)
  }

  if (email) {
    params.append('email', email)
  }

  if (offset) {
    params.append('offset', offset.toString())
  }

  if (link) {
    return fetch(`${url}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }).then((response) => response.json())
  }

  const response = await fetch(`${url}?${params.toString()}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  })

  if (link) {
    window.history.replaceState({}, '', baseUrl)
  }

  if (response.status === 401) {
    throw new Error('Sessão expirada')
  }

  return response.json() as Promise<EmployeesResponse>
}
